import React from 'react';

interface IContentWrapperProps {
  title: string;
  children: React.ReactNode;
}

const ContentWrapper = ({ title, children }: IContentWrapperProps) => (
  <div className="round m-8 flex flex-col text-kira-slate-900">
    <div className="prose-title-h1 w-full border-b border-kira-slate-200 pl-5">
      {title}
    </div>
    {children}
  </div>
);

export default ContentWrapper;
